/* eslint-disable multiline-ternary */
import React, { Fragment } from 'react'
import * as Logger from 'loglevel'
import { Overlay, OverlayTrigger, Tooltip, Popover} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faFileAudio, faEdit, faKey, faUserSlash, faUserCheck, faPlusCircle, faMinusCircle, faTasks, faRss, faArrowCircleRight, faSave, faLock } from '@fortawesome/free-solid-svg-icons'
import CollapsibleRow from './CollapsibleRow'
import { css } from '@emotion/core'
import ClipLoader from 'react-spinners/ClipLoader'
import { DataEditor } from '../../DataEditor/DataEditor'
import * as HubConstant from './util/HubConstant'
import * as _ from 'lodash'
import Utilities, { UtilConstant } from 'hub-utilities'
import { RotatingArrow } from '../../RotatingArrow/RotatingArrow'
import DateTimePicker from 'react-datetime-picker'
import EditableDiv from './tools/EditableDiv'
import '../styles/DataTable.scss'
import '../styles/Calendar.scss'
import { PopupContent } from '../../PopupContent/PopupContent'
import {TableRowAction} from './DataTable'

export default class TableRow extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showConfirmDelete: false,
            // confirm delete?
            idToConfirmDelete: -1,
            confirmDeleteTarget: null,
            // for downloading media:
            downloadingAllMediaIDs: []
        }
        this.maxActiveInPlaceEditingRows = 1
        this.confirmDeleteRef = React.createRef()
    }

    saveInPlaceEditingData = (event, inPlaceEditingAction, dataObj) => {
        if (event === undefined || event.key === 'Enter') {
          if (inPlaceEditingAction.onSaveInPlaceEditing) {
            inPlaceEditingAction.onSaveInPlaceEditing(
              this.props.inPlaceEditingRows.find((inPlaceEditingDataObj) => inPlaceEditingDataObj.id === dataObj.id)
            )
          } else {
            console.error('onSaveInPlaceEditing(dataObj) is not implemented')
          }
        }
      }

    isAuthorizedNode(dataObj) {
        switch (this.props.authorizeService.getUserType()) {
          case UtilConstant.HUB_USER_TYPE.HUB_ADMIN:
            break
          case UtilConstant.HUB_USER_TYPE.HUB_NODE_ADMIN:
            if (!!dataObj.ProductionCentre && dataObj.ProductionCentre.val !== this.props.authorizeService.getNodeNameByUserGuid()) {
              return false
            }
            break
          default:
            break
        }
        return true
      }
    
  isInteger(a) {
    return a >= 1e21 ? true : a === (a | 0)
  }

    getTableOrPageName() {
        if (this.props.activeTableName) {
          return this.props.activeTableName.singular.split(' ').join('\n')
        } else if (this.props.activePageName) {
          return this.props.activePageName.singular.split(' ').join('\n')
        }
        return ''
      }

    setEditingRow = (rowIndex) => {
        if (rowIndex === this.props.editingRowIndex) {
          // Set editing row to none
          this.props.setEditingRowIndex(-1)
        } else {
          this.props.setEditingRowIndex(rowIndex)
        }
      }

      setInPlaceEditingRow = async (id, name, key, oldVal, newVal, isDate, isUtc, isExactDate) => {
        if (name === undefined)
          Logger.error("'name' attribute is needed for in-place editing row!")
    
        var oldComparisonVal = oldVal
        var newComparisonVal = newVal
        if (isDate) {
          var oldDate = new Date(oldVal)
          oldDate.setSeconds(0, 0)
          oldDate.setMilliseconds(0, 0)
          oldComparisonVal = oldDate.toISOString()
    
          var newDate = new Date(newVal)
          newDate.setSeconds(0, 0)
          newDate.setMilliseconds(0, 0)
          newComparisonVal = newDate.toISOString()
        }

          // [{id: -1, data:[{key, val, isCollapsible}]}]
          var newEditingRows = this.props.inPlaceEditingRows
          var correspondingIdIndex = newEditingRows.findIndex(
            (editingRow) => editingRow.id === id
          )
          if (correspondingIdIndex > -1) {
            // if id is found
            var correspondingAttrIndex = newEditingRows[correspondingIdIndex].data.findIndex((attr) => attr.key === key)
            if (correspondingAttrIndex < 0) {
              // if key isn't found
              if (oldComparisonVal !== newComparisonVal)
                newEditingRows[correspondingIdIndex].data.push({
                  key: key,
                  val: isDate ? Utilities.formatObjectDate(newVal, UtilConstant.HUB_TIME_FORMAT.CANADIAN, isExactDate, isUtc) : newVal,
                  ...{ date: newVal }
                })
            } else {
              if (oldComparisonVal !== newComparisonVal) {
                if (isDate) {
                  newEditingRows[correspondingIdIndex].data[correspondingAttrIndex].val = Utilities.formatObjectDate(newVal, UtilConstant.HUB_TIME_FORMAT.CANADIAN, isExactDate, isUtc)
                  newEditingRows[correspondingIdIndex].data[correspondingAttrIndex].date = newVal
                } else {
                  newEditingRows[correspondingIdIndex].data[correspondingAttrIndex].val = newVal
                }
              } else {
                newEditingRows[correspondingIdIndex].data = newEditingRows[correspondingIdIndex].data.filter((attr) => attr.key !== key)
              }
            }
          } else {
            correspondingIdIndex = 0
            newEditingRows.push({
              id: id, name: name,
              data: [
                {
                  key: key,
                  ...(oldComparisonVal !== newComparisonVal && {
                    val: isDate ? Utilities.formatObjectDate( newVal, UtilConstant.HUB_TIME_FORMAT.CANADIAN, isExactDate, isUtc) : newVal,
                    ...{ date: newVal }
                  })
                }
              ]
            })
          }
          // Delete the correspondingIdIndex row if data length is 0
          if (newEditingRows[correspondingIdIndex].data.length <= 0)
            newEditingRows.splice(correspondingIdIndex, 1)
          await this.props.setInPlaceEditingRows(newEditingRows)
        
      }

      onChangeEditingRow = (id, setInPlaceEditingRowCallback) => {
        if (
          this.props.inPlaceEditingRows.length < this.maxActiveInPlaceEditingRows ||
          this.props.inPlaceEditingRows.some((editingRow) => editingRow.id === id)
        ) {
          setInPlaceEditingRowCallback()
        } else {
          this.props.openUnsavedChangesPrompt(false, false)
        }
      }
    
  onRowAction = async (event, rowAction, selectedData, indexPerPage, dataObj, additionalParams) => {
    // Redux delete table calls API:
    var index = indexPerPage + (this.props.currentPageNum - 1) * this.props.numOfRowsPerPage
    Logger.debug(rowAction)

    // customized onClick handler:
    if (!!additionalParams && !!additionalParams.onClick) {
      additionalParams.onClick()
    }

    switch (rowAction) {
      case TableRowAction.DELETE_ROW:
        if (this.props.data[index].type !== HubConstant.HUB_PRODUCTION_GROUP && this.props.data[index].type !== HubConstant.HUB_METADATA && this.props.data[index].type !== HubConstant.HUB_VOCABULARY && !this.props.isPageless) {
          this.props.setLocallyDeletedRowIDs(this.props.locallyDeletedRowIDs.concat([this.props.data[index].id]))
          
          var idToDelete = !!this.props.filteredData && this.props.filteredData.length > 0 ? this.props.filteredData[index].id : this.props.data[index].id;
          this.props.onDeleteObjectClick(this.props.filteredData[index].type, idToDelete, this.props.folder.id)
          this.isDeleting = true
        } else if (!!this.props.activeTableName && this.props.activeTableName.singular === 'Value') {
          // delete from given function
          this.props.onDeleteRow(this.props.data[index].id)
          this.props.setAreDataOfRightType(Utilities.verifyAllVocabsHaveCorrectDataType(this.props.data.map((vocab) => vocab.Value.val), parseInt(this.props.requiredDataType)))
        } else if (!!this.props.activeTableName &&this.props.activeTableName.singular === 'Data Field') {
          this.props.onDeleteRow(this.props.data[index].id)
        } else {
          this.props.deleteNodeGroup(
            this.props.data[index].id,
            this.props.data[index].Members.formVal
          )
        }

        break

      case TableRowAction.CONFIRM_DELETE:
        this.setState(
          {
            showConfirmDelete: true,
            idToConfirmDelete: !!this.props.filteredData && this.props.filteredData.length > 0 ? this.props.filteredData[index].id : this.props.data[index].id,
            confirmDeleteTarget: event.target
          }, () => {
            // Have to ensure that confirmDeleteTarget is set here before showing the confirmDelete prompt...
            this.setState({ showConfirmDelete: true })
            Logger.debug('showConfirmDelete: ', this.state.showConfirmDelete)
            Logger.debug('idToConfirmDelete: ', this.state.idToConfirmDelete)
            Logger.debug('confirmDeleteTarget: ', this.state.confirmDeleteTarget)
          }
        )
        break

      case TableRowAction.DISABLE:
        if (selectedData[index].State === undefined || selectedData[index].State.val === undefined) {
          console.error('There has to be a column named State w/ values Active/Inactive!')
          break
        }
        if (selectedData[index].State.val === 'Active') {
          additionalParams.onDisable(selectedData[index].id)
        } else {
          additionalParams.onEnable(selectedData[index].id)
        }

        break
      case TableRowAction.RSS_FEED: {
        const rssLink = this.props.data[index].id === undefined ? `/api/NewsFeed/content.rss` : `/api/NewsFeed/content/${this.props.data[index].id}.rss`
        // rssLink += `?oauth_token=${authService.getAccessToken()}`;
        window.open(rssLink)
        break
      }
      case TableRowAction.NAVIGATE_TO:
        if (additionalParams.onNavigate === undefined || additionalParams.url === undefined) {
          Logger.error('Parameter [func onNavigate(param)] and/or [urls] is missing in the TableRowAction.NAVIGATE_TO rowAction prop')
        } else {
          // helper.parseUrl();
          // var parsedUrl = Utilities.parseUrl(additionalParams.url, dataObj, additionalParams.dataParsingKeys)
          additionalParams.onNavigate(additionalParams.url, dataObj)
        }
        break

      case TableRowAction.IN_PLACE_EDITING:
        this.saveInPlaceEditingData(undefined, additionalParams, dataObj)
        break

      case TableRowAction.POPUP_CONTENT:
        Logger.debug(dataObj.id)
        Logger.debug(this.props.editingRowIndex)
        break

      case TableRowAction.DOWNLOAD_ALL_MEDIA:
        // prevents user from spamming clicks to download while it is in fact downloading
        if (!this.state.downloadingAllMediaIDs.includes(dataObj.id)) {
          this.setState((prevState) => ({downloadingAllMediaIDs: [ ...prevState.downloadingAllMediaIDs, dataObj.id]}), async () => {
            await additionalParams.onClickDownloadAllMedia(dataObj.id)
            this.setState({downloadingAllMediaIDs: this.state.downloadingAllMediaIDs.filter((id) =>  id !== dataObj.id)})
          })
        }
        break

      case TableRowAction.ADD_ROW_EDITOR:
      case TableRowAction.EDIT_ROW_EDITOR:
      /* falls through */
      case TableRowAction.MOVE_FOLDER_ROW:
        this.props.setLocallyDeletedRowIDs(this.props.locallyDeletedRowIDs.concat([this.props.data[index].id]))
        break
      default:
        break
    }
  }

    displaySubObjectCount(subObjectCount) {
        return (
          <Fragment>
            <FontAwesomeIcon className='numOfMediaIcon' icon={faFileAudio} />
            <span className='numOfMediaBackground' />
            <div className='numOfMedia'>{subObjectCount}</div>
          </Fragment>
        )
      }

    addRowEditor(rowAction, index, dataObj) {
        return (
          <td key={`addRowEditor_${index}_${dataObj.id}`}>
            <DataEditor
              id={dataObj.id}
              title={`${rowAction === TableRowAction.ADD_ROW_EDITOR ? 'Add' : 'Edit'} ${this.getTableOrPageName()}`}
              toggleIcon={rowAction === TableRowAction.ADD_ROW_EDITOR ? faPlusCircle : faEdit}
              mediaEditInfo={dataObj.rowEditorData}
              isActive={this.props.editingRowIndex === dataObj.id}
              initialVal={this.props.rowEditorConfig.hasInitialVal ? Utilities.findDataObjAttrContainingVal(dataObj).val : ''}
              isRightDataType={Utilities.findDataObjAttrContainingVal(dataObj) ? 
                Utilities.verifyDataHasCorrectDataType(Utilities.findDataObjAttrContainingVal(dataObj).val, parseInt(this.props.requiredDataType))  : null}
              placement='bottom-end'
              onToggle={this.setEditingRow}
              onSubmit={this.props.onSubmitRowEditor}
            />
          </td>
        )
      }

      // Authority-based change password:
  onAuthorizedChangePassword(dataObj, data, index, form) {
    return this.renderActionRow(
      'changePasswordRow',
      { icon: faKey },
      <Fragment>Change<br />Password</Fragment>,
      <Fragment>You can only<br />manage your own<br /> production centre</Fragment>,
      null, form, TableRowAction.CHANGE_PASSWORD, dataObj, data, index
    )
  }
  
  
  // Authority-based change password:
  onAuthorizedDeactivateUser(dataObj, data, index, disableAction) {
    if (!!dataObj.State && dataObj.State.val === 'Active') {
      return this.renderActionRow(
        'DisableRow',
        !!disableAction.icon && !!disableAction.icon.disabled ? { icon: disableAction.icon.disabled } : { icon: faUserSlash },
        <Fragment>Deactivate<br />{this.getTableOrPageName()}</Fragment>,
        <Fragment>You can only<br />manage your own<br /> production centre</Fragment>,
        <Fragment>You May Not<br />Deactivate<br />Yourself</Fragment>,
        null, TableRowAction.DISABLE, dataObj, data, index, disableAction
      )
    } else {
      return this.renderActionRow(
        'DisableRow',
        !!disableAction.icon && !!disableAction.icon.enabled ? { icon: disableAction.icon.enabled } : { icon: faUserCheck },
        <Fragment>Activate<br />{this.getTableOrPageName()}</Fragment>,
        <Fragment>You can only<br />manage your own<br /> production centre</Fragment>,
        <Fragment>You May Not<br />Activate<br />Yourself</Fragment>,
        null, TableRowAction.DISABLE, dataObj, data, index, disableAction
      )
    }
  }

  
  renderActionIcon(rowKey, iconInfo, isAuthorized, form, rowAction, dataObj, data, index, additionalParams) {
    return (
      <td
        key={`${rowKey}_td_${dataObj.id}`}
        className={`${rowKey} ${!isAuthorized || (!!additionalParams && !!additionalParams.disableCondition) ? 'disabledWithTooltip' : ''
        } rowAction`}
        onClick={(e) => {
          Logger.debug('isAuthorized: ', isAuthorized)
          Logger.debug('additionalParams: ', additionalParams)
          Logger.debug('form: ', form)
          Logger.debug('dataObj: ', dataObj)
          Logger.debug('rowAction: ', rowAction)
          if (isAuthorized && !(!!additionalParams && !!additionalParams.disableCondition)) {
            if (form) {
              this.props.onOpenForm(form, rowAction, dataObj)
            } else {
              this.onRowAction(e, rowAction, data, index, dataObj, additionalParams)
            }
          }
        }}
      >
        {rowAction === TableRowAction.POPUP_CONTENT ? (
          <PopupContent
            id={dataObj.id}
            title={additionalParams.title}
            content={additionalParams.content}
            button={
              iconInfo.imageUrl ? (
                <img className={!isAuthorized ? `disabled` : ''} src={iconInfo.imageUrl} />
              ) : (
                <FontAwesomeIcon className={!isAuthorized ? `disabled` : ''} icon={iconInfo.icon}/>
              )
            }
            isActive={this.props.editingRowIndex === dataObj.id}
            placement='bottom-start'
            onToggle={() => this.setEditingRow(this.props.editingRowIndex === dataObj.id ? -1 : dataObj.id)}
          />
        ) : rowAction === TableRowAction.DOWNLOAD_ALL_MEDIA && this.state.downloadingAllMediaIDs.includes(dataObj.id) ? (
          <ClipLoader size={15} color='black' loading={this.props.loading} />
        ) : iconInfo.imageUrl ? (
          <img className={!isAuthorized ? `disabled` : ''} src={iconInfo.imageUrl}/>
        ) : (
          <FontAwesomeIcon
            className={!isAuthorized ? `disabled` : ''}
            icon={iconInfo.icon}
          />
        )}
      </td>
    )
    }

    checkFolderPermission = (action) => {
        return !this.props.folder || (
            this.props.folder &&
            this.props.folder.folderPermissions &&
            action &&
            action.userPermission &&
            (this.props.folder.folderPermissions & action.userPermission) === action.userPermission
        );
    }

  renderActionRow(rowKey, iconInfo, authorizedTooltipText, unauthorizedTooltipText, disallowSelfText, form, rowAction, dataObj, data, index, additionalParams) {
    // Logger.debug(form);
    // this.props.folder.folderPermissions

    // const isAuthorizedRole = dataObj.rowActions.some((action) =>
    //   action.action === rowAction && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    // )

    const isAuthorizedRole = dataObj.rowActions.some((action) =>
        //action.action === rowAction && (!this.props.folder || ((this.props.folder?.folderPermissions & action.userPermission) === action?.userPermission))
        action.action === rowAction && this.checkFolderPermission(action)
    )

    var isAuthorized = isAuthorizedRole && (this.isAuthorizedNode(dataObj) || (!!additionalParams && additionalParams.disableNodeAuthorityCheck))
    // const shouldShowRowAction = dataObj.rowActions.some((action) =>
    //   action.action === rowAction && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    // )

    const shouldShowRowAction = dataObj.rowActions.some((action) =>
        //action.action === rowAction && (!this.props.folder || ((this.props.folder?.folderPermissions & action.userPermission) === action?.userPermission))
        action.action === rowAction && this.checkFolderPermission(action)
    )

    const isSelf = dataObj.userGuid === this.props.authorizeService.getUserGuid()

    if (isAuthorized && !!disallowSelfText) isAuthorized = !isSelf

    if (shouldShowRowAction) {
      return (
        <OverlayTrigger
          key={`${rowKey}_${dataObj.id}`}
          placement='bottom'
          overlay={
            <Tooltip className='rowActionTooltip'>
              {!!additionalParams && !!additionalParams.tooltipText ? additionalParams.tooltipText
                : isSelf && !!disallowSelfText ? disallowSelfText
                : !isAuthorized ? unauthorizedTooltipText : authorizedTooltipText}
            </Tooltip>
          }
        >
          {this.renderActionIcon(rowKey, iconInfo, isAuthorized, form, rowAction, dataObj, data, index, additionalParams)}
        </OverlayTrigger>
      )
    } else {
      return <Fragment />
    }
  }


    async fetchAndSetCollapsibleAPIData(dataObj) {
        Logger.debug("fetchAndSetCollapsibleAPIData")
        Logger.debug("dataObj= ",dataObj)
        if (dataObj.Collapsible.fetchData) {
          Logger.debug("dataObj.Collapsible.fetchData")
          await dataObj.Collapsible.fetchData()
        }
        if (dataObj.Collapsible.fetchNewsItemMetadata) {
          Logger.debug("dataObj.Collapsible.fetchNewsItemMetadata)")
          await dataObj.Collapsible.fetchNewsItemMetadata(dataObj.id)
        }
      }

      // API CALL HERE TO FETCH WHEN COLLAPSIBLE IS TOGGLED OPEN:
  // binding function:
  toggleCollapse = async (dataObj, index) => {
    if (dataObj.Collapsible.state === HubConstant.HUB_COLLAPSIBLE_ROW_STATE.LOADING) return

    // for loading icon:
    // updated redux code identifies whether collapsible data is loading, use that instead
    // disable collapse animation on load to prevent jerky animations:
    Logger.debug("dataObj= ",dataObj)
    Logger.debug("dataObj.Collapsible.state= ",dataObj.Collapsible.state)
    Logger.debug("setIsCollapsedAnimDisabled outisde start")
    this.props.setIsCollapsedAnimDisabled(dataObj.Collapsible.state === HubConstant.HUB_COLLAPSIBLE_ROW_STATE.UNINITIALIZED)
    Logger.debug("setIsCollapsedAnimDisabled outisde finish")
    if (dataObj.Collapsible.state === HubConstant.HUB_COLLAPSIBLE_ROW_STATE.UNINITIALIZED) {
      await this.fetchAndSetCollapsibleAPIData(dataObj)
    }

    // add the arrOfExpandedCollapableRowIDs if it's not already there, or else don't:
    var newArrOfExpandedCollapableRowIDs = []
    if (this.props.arrOfExpandedCollapableRowIDs.includes(dataObj.id)) {
      newArrOfExpandedCollapableRowIDs = this.props.arrOfExpandedCollapableRowIDs.filter(
        (id) => id !== dataObj.id
      )
    } else {
      newArrOfExpandedCollapableRowIDs = [...this.props.arrOfExpandedCollapableRowIDs, dataObj.id]
    }

    this.props.setArrOfExpandedCollapableRowIDs(newArrOfExpandedCollapableRowIDs)
  }
    
    onRowAnimEnd = (dataObj) => {
        var animating = []
        var animated = []
        var animatingKey
        var animatedKey
    
        if (this.props.arrOfJustModifiedRows.findIndex((modifiedDataObj) => !!modifiedDataObj.val && modifiedDataObj.val.id === dataObj.id) > -1) {
          animating = this.props.arrOfJustModifiedRows
          animated = this.props.arrOfModifiedRows
          animatingKey = 'arrOfJustModifiedRows'
          animatedKey = 'arrOfModifiedRows'
        }
    
        const index = animating.findIndex((newDataObj) => (!!newDataObj.id && newDataObj.id === dataObj.id) || (!!newDataObj.val && newDataObj.val.id === dataObj.id))
        if (index > -1) {
          var objToBePushed = Object.assign({}, animating[index])
          animated.push(objToBePushed)
          animating.splice(index, 1)
        }
    
        this.setState({ [animatingKey]: animating, [animatedKey]: animated })
      }

      renderDataVal(dataObj, key, dataVal, dataTypeError, checkboxDataHtmlAry) {
        if (dataObj[key].isEditable) {
          // [{id, data:[{key, val, isCollapsible}]}]
          var editingRow = this.props.inPlaceEditingRows.find((editingRow) => editingRow.id === dataObj.id)
          var editingAttr = null
          if (editingRow)
            editingAttr = editingRow.data.find((dataAttr) => dataAttr.key === key)
    
          var inPlaceEditingAction = dataObj.rowActions.find(
            (action) =>
              action.action === TableRowAction.IN_PLACE_EDITING &&
              this.props.authorizeService.getUserType() <= action.minAuthorityRequired
          )
    
          if (dataObj[key].date || dataObj[key].date === null) {
            return (
              <div
                className={this.props.inPlaceEditingDateRowId === dataObj.id ? '' : 'inPlaceEditingDateWrapper'}
                onClick={() => { this.props.setInPlaceEditingDateRowId(dataObj.id)}}
              >
                {this.props.inPlaceEditingDateRowId === dataObj.id ? (
                  <DateTimePicker
                    className={`inPlaceEditingDateTimePicker ${inPlaceEditingAction.disableTimeEditing ? 'disableTimeEditing'  : ''}`}
                    onChange={(e) =>
                      this.onChangeEditingRow(dataObj.id, () =>
                        this.setInPlaceEditingRow(dataObj.id, dataObj.name, key, dataObj[key].date, new Date(e).toISOString(), true, dataObj[key].isUtc, dataObj[key].isExactDate)
                      )
                    }
                    value={!!editingRow && !!editingAttr ? new Date(editingAttr.date)  : new Date(dataObj[key].date == null ? Utilities.addDays(new Date(), 5) : dataObj[key].date)}
                    format='MMMdd, yyyy hh:mma'
                    clearIcon={null}
                    calendarIcon={null}
                    disableClock
                  />
                ) : (
                <Fragment>{!!editingRow && !!editingAttr ? editingAttr.val : dataObj[key].val}</Fragment>
                )}
              </div>
            )
          } else if (this.isInteger(dataObj[key].val)) {
            return (
              <input
                type='number'
                onChange={(e) =>
                  this.onChangeEditingRow(dataObj.id, () =>
                    this.setInPlaceEditingRow(dataObj.id, dataObj.name, key, dataObj[key].val, e.target.value)
                  )
                }
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    // this.saveInPlaceEditingData(e, inPlaceEditingAction, dataObj)
                    e.target.blur()
                  }
                }}
                className='transparentTextInput'
                defaultValue={dataObj[key].val}
              />
            )
          } else {
            return (
              <EditableDiv
                html={!!editingRow && !!editingAttr ? editingAttr.val : dataObj[key].val}
                onChange={(e) => {
                  if (!(e.target.value.includes('<div>') || e.target.value.includes('<br>'))) {
                    this.onChangeEditingRow(dataObj.id, () =>
                      this.setInPlaceEditingRow( dataObj.id, dataObj.name, key, dataObj[key].val, e.target.value)
                    )
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    // this.saveInPlaceEditingData(e, inPlaceEditingAction, dataObj)
                    e.target.blur()
                  }
                }}
              />
            )
          }
        } else {
          return (
            <div
              className={!!this.props.dataKeys.find((k) => key === k.key) &&!!this.props.dataKeys.find((k) => key === k.key).hasRowIcon ? `dataValNextToIcon` : ''}
            >
              {!!dataObj[key].shouldShowCheckbox && !!dataObj[key].formVal && dataObj[key].formVal.length > 0 ? (checkboxDataHtmlAry) : 
                typeof dataVal === 'string' || typeof dataVal === 'undefined' || dataVal == null ? ( `${dataVal || ''} `) : (
                <Fragment>{dataVal}</Fragment>
              )}
              {dataTypeError}
            </div>
          )
        }
      }
      
  renderData(dataObj, key) {
    var isDate = !!dataObj[key].date
    var dataVal =
      typeof dataObj[key].val === 'string' &&
      Utilities.verifyDataHasCorrectDataType(dataObj[key].val, UtilConstant.HUB_DATA_TYPE.DATETIME)
        ? Utilities.formatObjectDate(dataObj[key].date ? dataObj[key].date : dataObj[key].val + '.000Z', UtilConstant.HUB_TIME_FORMAT.CANADIAN, true, !!dataObj[key].isUtc)
        : dataObj[key].val

    var checkboxDataHtmlAry = []
    if (
      !!dataObj[key].shouldShowCheckbox &&
      !!dataObj[key].formVal &&
      dataObj[key].formVal.length > 0
    ) {
      var dataStrAry = dataVal.split('; ')

      for (var i = 0; i < dataStrAry.length; i++) {
        var dataStr = dataStrAry[i]
        var checkbox = (
          <label className='checkboxContainer'>
            <input
              id={`val_checkbox_${dataObj.id}_${dataObj[key].formVal[i].index}`}
              name={i}
              value={i}
              className='filterGroupChild'
              label=''
              type='checkbox'
              onClick={(e) => {
                Logger.debug(e.target)
                this.props.onSelectValue(
                  dataObj.id,
                  dataObj[key].formVal[parseInt(e.target.value)].index
                )
              }}
              checked={dataObj[key].formVal[i].isChecked !== undefined ? dataObj[key].formVal[i].isChecked : false}
            />
            <span className='checkmark' />
          </label>
        )

       
        var deleteRowVal = dataObj.rowActions.some((action) =>
            action.action === TableRowAction.DELETE_ROW_VALUE && (!this.props.folder || this.checkFolderPermission(action)) // this.props.authorizeService.getUserType() <= action.minAuthorityRequired
        ) ? (
          <OverlayTrigger
            key='DeleteRowVal'
            placement='bottom'
            overlay={<Tooltip className='rowActionTooltip'>Delete</Tooltip>}
          >
            <span
              key={`delete_row_val_${dataObj[key].id}`}
              name={i}
              className='DisableRow'
              onClick={(e) => {
                Logger.debug(e.currentTarget.getAttribute('name'))
                this.props.onDeleteSelectedVal(dataObj.id, dataObj[key].formVal[parseInt(e.currentTarget.getAttribute('name'))].index)
              }}
              style={{ paddingRight: '4px', paddingTop: '10px', paddingBottom: '10px' }}
            >
              <FontAwesomeIcon 
              icon={faTrash}/>
            </span>
          </OverlayTrigger>
        ) : (
          <Fragment />
        )

        checkboxDataHtmlAry.push(
          <Fragment key={`fragment_checkbox_${dataObj.id}_${i}`}>
            {checkbox}
            <span className='dataStr'>{`${dataStr} `}</span>
            {deleteRowVal}&nbsp;&nbsp;{' '}
          </Fragment>
        )
      }
    }

    var dataTypeError = !!this.props.requiredDataType && !Utilities.verifyDataHasCorrectDataType(dataObj.Value.val, parseInt(this.props.requiredDataType)) ? (
        <span style={{ color: 'red', fontStyle: 'italic', fontWeight: 400 }}>{' '}Data Type Mismatch</span>
      ) : (
        <Fragment />
      )

    return (
      <Fragment key={`renderData_Fragment${key}`}>
        {dataObj[key].rowIcon ? (
          <OverlayTrigger
            key={`dataIcon${key}`}
            placement='bottom'
            overlay={<Tooltip className='rowActionTooltip'>Recent {this.getTableOrPageName()}</Tooltip>}
          >
            <div className='dataIcon'>{dataObj[key].rowIcon}</div>
          </OverlayTrigger>
        ) : (
          <Fragment />
        )}
        {isDate && !dataObj[key].isEditable ? (
          <OverlayTrigger
            key={`date${key}`}
            placement='bottom'
            overlay={<Tooltip className='rowActionTooltip'>{Utilities.formatObjectDate(dataObj[key].date, UtilConstant.HUB_TIME_FORMAT.CANADIAN, true, !!dataObj[key].isUtc, true)}</Tooltip>}
          >
            {this.renderDataVal(dataObj, key, dataVal, dataTypeError, checkboxDataHtmlAry)}
          </OverlayTrigger>
        ) : (
          this.renderDataVal(dataObj, key, dataVal, dataTypeError, checkboxDataHtmlAry)
        )}
      </Fragment>
    )
  }

  // index is PER PAGE
  // RMB TO PARSETO INT BEFORE RUNNNING SWITCH CASE................
  generateTableRowData(data, dataObj, index, dataAction) {
    var keys = Object.keys(dataObj)
    if (keys.length) {

      var dataRows = [
        <tr
          key={`TableRowData${index}`}
          className={`${index % 2 === 0 ? 'oddRow data' : 'evenRow data'}
        ${
          !!this.props.requiredDataType &&
          !Utilities.verifyDataHasCorrectDataType(dataObj.Value.val, parseInt(this.props.requiredDataType)) ? 'wrongDataType' : ''
        }
        ${
          this.props.arrOfJustModifiedRows.findIndex((modifiedDataObj) => !!modifiedDataObj.val && modifiedDataObj.val.id === dataObj.id) > -1 ? 'justModifiedRow'
            : this.props.arrOfModifiedRows.findIndex((modifiedDataObj) => !!modifiedDataObj.val && modifiedDataObj.val.id === dataObj.id) > -1 ? 'modifiedRow'
            : ''
        }
        ${!!dataObj.State && dataObj.State.val === 'InActive' ? 'inActiveRow' : ''
        } ${ dataObj.isUrgent !== undefined && dataObj.isUrgent ? 'urgent' : '' }`}
          onAnimationEnd={() => { this.onRowAnimEnd(dataObj) }}
        >
          {this.generateTableData(data, dataObj, keys, index, dataAction)}
        </tr>
      ]

      if (dataObj.Collapsible)
        dataRows.push(
          <Fragment key={`collapsible_row_${dataObj.id}`}>
            <CollapsibleRow
              id={dataObj.id}
              title={dataObj.Title.val}
              collapsibleData={dataObj.Collapsible}
              dataObj={dataObj}
              onOpenForm={this.props.onOpenForm}
              onRowAction={this.onRowAction}
              data={data}
              className={`${this.props.isCollapsedAnimDisabled? 'disableCollapsingParent' : ''}`}
              index={index}
              isCollapsedAnimDisabled={this.props.isCollapsedAnimDisabled}
              isNotCollapsed={this.props.arrOfExpandedCollapableRowIDs.includes(
                dataObj.id
              )}
              numOfTableCols={this.props.numOfCols}
              isUrgent={dataObj.isUrgent}
              activePageName={this.props.activePageName}
              activeTableName={this.props.activeTableName}
              inPlaceEditingRows={this.props.inPlaceEditingRows}
              setInPlaceEditingRow={this.setInPlaceEditingRow}
              authorizeService={this.props.authorizeService}
              isFullTextSearchActive={this.props.isFullTextSearchActive}
              folderPermissions={this.props.folder && this.props.folder.folderPermissions}
            />
          </Fragment>
        )

      return dataRows
    }
    return <Fragment />
  }

    // index is PER PAGE
  generateTableData(data, dataObj, dataObjKeys, index, dataAction) {
    var tableData = []
    if (!!dataObj.rowActions) {
      if (
        dataObj.rowActions.some(
          (action) =>
            action.action === TableRowAction.CHECKBOX // && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
        )
      ) {
        tableData.push(
          <td key={`checkbox_${dataObj.id}`} className='checkboxRow'>
            <label className='checkboxContainer'>
              <input
                id={`checkbox_${dataObj.id}`}
                name={`checkbox_${dataObj.id}`}
                className='filterGroupChild'
                type='checkbox'
                onChange={() => { this.props.onChangeSetData(dataObj.id) }}
                checked={dataObj.isChecked !== undefined ? dataObj.isChecked : false}
              />
              <span className='checkmark' />
            </label>
          </td>
        )
      }
    }

    const collapsibleLoaderOverride = css`
      position: absolute;
      top: 20%;
      left: 25px;
      box-sizing: content-box;
    `

    // for collapsibleRows:
    if (this.props.hasCollapsibleRows) {
      tableData.push(
        <td
          className='collapseToggler'
          key={`CollapsableRow${index}`}
          onClick={() => { this.toggleCollapse(dataObj, index) }}
        >
          {dataObj.subObjectCount !== undefined && dataObj.subObjectCount > 0 ? (
            <OverlayTrigger
              key={`CollapsableRow_SubobjectCount_${index}`}
              placement='bottom'
              overlay={<Tooltip>has {dataObj.subObjectCount}<br />media<br />item{dataObj.subObjectCount > 1 ? 's' : ''}</Tooltip>}
            >
              <div className='numOfMediaBadge'>
                {this.displaySubObjectCount(dataObj.subObjectCount)}
              </div>
            </OverlayTrigger>
          ) : (
            <Fragment />
          )}
          <RotatingArrow isRowExpanded={this.props.arrOfExpandedCollapableRowIDs.includes(dataObj.id)} isInitiallyExpanded={false}/>
          {dataObj.Collapsible.state === HubConstant.HUB_COLLAPSIBLE_ROW_STATE.LOADING ? (
            <ClipLoader
              size={15}
              color='black'
              loading={this.props.loading}
              css={collapsibleLoaderOverride}
            />
          ) : (
            <Fragment />
          )}
        </td>
      )
    }
    // for each obj key generate td:
    dataObjKeys.forEach((key) => {
      if (key !== 'Collapsible' && key[0] === key[0].toUpperCase())
        // to prevent details being mapped, and just upper case
        tableData.push(
          <td
            style={dataObj[key].color ? { color: dataObj[key].color, fontWeight: 700 } : {}}
            key={`collapsed_${key}`}
            className={!!dataObj[key].val && typeof dataObj[key].val === 'string' && dataObj[key].val.includes('Loading') ? 'loading' : ''}
          >
            {this.renderData(dataObj, key)}
          </td>
        )
    })
    if (!!dataObj.rowActions) {
    if (
      dataObj.rowActions.some(
        (action) =>
          action.action === TableRowAction.ADD_ROW_EDITOR && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
      )
    ) {
      tableData.push(this.addRowEditor(TableRowAction.ADD_ROW_EDITOR, index, dataObj))
    }

    if (
      dataObj.rowActions.some(
        (action) =>
          action.action === TableRowAction.EDIT_ROW_EDITOR && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
      )
    ) {
      tableData.push(this.addRowEditor(TableRowAction.EDIT_ROW_EDITOR, index, dataObj))
    }

        var editRowAction = dataObj.rowActions.find(
            (action) =>
                action.action === TableRowAction.EDIT_ROW  // this.props.authorizeService.getUserType() <= action.minAuthorityRequired
        )

        if (editRowAction) {
            tableData.push(
                <OverlayTrigger
                    key={`editRow_${dataObj.id}`}
                    placement='bottom'
                    overlay={<Tooltip className='rowActionTooltip' style={{ paddingLeft: '40px' }}>{`Edit ${this.getTableOrPageName()}\nProperties`}</Tooltip>}
                >
                    <td
                        key={`edit_${dataObj.id}`}
                        className='editRow'
                        onClick={() => { this.props.onOpenForm(editRowAction.form, editRowAction.action, dataObj) }}
                    >
                        <FontAwesomeIcon icon={faTasks} />
                    </td>
                </OverlayTrigger>
            )
        }

        var editInfoByFormAction = dataObj.rowActions.find(
            (action) =>
                action.action === TableRowAction.EDIT_INFO_BY_FORM &&
                this.props.authorizeService.getUserType() <= action.minAuthorityRequired
        )
        if (editInfoByFormAction) {
            const isEditInfoVisible = ( editInfoByFormAction &&
                (!this.props.folder || this.checkFolderPermission(editInfoByFormAction)))
                       && (dataAction !== HubConstant.HUB_ACTION_STATE.ELASTIC_SEARCH);
            const isLocked = editInfoByFormAction && editInfoByFormAction.isLocked;
            const lockUserName = editInfoByFormAction && editInfoByFormAction.lockUserName;

            tableData.push(
                <OverlayTrigger
                    key={`editInfoByFormRow_${dataObj.id}`}
                    placement='bottom'
                    overlay={
                        <Tooltip className='rowActionTooltip'>
                            {isLocked ? `Locked by ${lockUserName}` : (editInfoByFormAction.tooltipText || 'Edit')}
                        </Tooltip>
                    }
                >
                    <td
                        key={`edit_info_${dataObj.id}`}
                        className={`editUserInfoRow ${isLocked ? 'disabled disabledWithTooltip' : ''} rowAction`}
                        onClick={(e) => {
                            if (!isLocked && isEditInfoVisible) {  
                                this.props.onOpenForm(editInfoByFormAction.form, editInfoByFormAction.action, { ...dataObj, ...editInfoByFormAction.data })
                            }
                        }}
                        style={{
                            pointerEvents: (isEditInfoVisible && !isLocked) ? 'auto' : 'none',  
                        }}
                    >
                        <FontAwesomeIcon
                            icon={isLocked ? faLock : faEdit}
                            style={{
                                visibility: isEditInfoVisible ? 'visible' : 'hidden',  
                            }}
                        />
                    </td>
                </OverlayTrigger>
            )
        }

        if (
            dataObj.rowActions.some(
                (action) =>
                    action.action === TableRowAction.RSS_FEED &&
                    this.props.authorizeService.getUserType() <= action.minAuthorityRequired
            )
        ) {
            tableData.push(
                this.renderActionRow('getRssFeed', { icon: faRss },
                    <Fragment>Get RSS Feed</Fragment>,
                    <Fragment>You can only<br />get RSS Feed<br />from your own<br />production centre</Fragment>,
                    null, null, TableRowAction.RSS_FEED, dataObj, data, index)
            )
        }

    var editProductionGroupAction = dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.EDIT_PRODUCTION_GROUP &&
        this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )
    if (editProductionGroupAction) {
      tableData.push(
        <OverlayTrigger
          key={`editProductionGroupRow_${dataObj.id}`}
          placement='bottom'
          overlay={<Tooltip className='rowActionTooltip'>Edit<br />Production<br />Group</Tooltip>}
        >
          <td
            key={`edit_production_group${dataObj.id}`}
            className='editProductionGroupRow'
            onClick={() => { this.props.onOpenForm(editProductionGroupAction.form, editProductionGroupAction.action, dataObj) }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </td>
        </OverlayTrigger>
      )
    }

    var editMetadata = dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.EDIT_METADATA &&
           this.checkFolderPermission(action)
    )
    if (editMetadata) {
      tableData.push(
        <OverlayTrigger
          key={`editMetadataRow_${dataObj.id}`}
          placement='bottom'
          overlay={<Tooltip className='rowActionTooltip'>Edit<br />Data<br />Field</Tooltip>}
        >
          <td
            key={`edit_metadata${dataObj.id}`}
            className='editMetadataRow'
            onClick={() => { this.props.onOpenForm(editMetadata.form, editMetadata.action, dataObj) }}
          >
            <FontAwesomeIcon icon={faEdit} />
          </td>
        </OverlayTrigger>
      )
    }

    var changePasswordAction = dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.CHANGE_PASSWORD && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )
    if (changePasswordAction) {
      tableData.push(
        this.onAuthorizedChangePassword({ ...dataObj, ...changePasswordAction.data }, data, index, changePasswordAction.form)
      )
    }

    var disableAction = dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.DISABLE &&
        this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )
    if (disableAction) {
      tableData.push(
        this.onAuthorizedDeactivateUser(dataObj, data, index, disableAction)
      )
    }

    var inPlaceEditingAction = dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.IN_PLACE_EDITING &&
        this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )
    if (inPlaceEditingAction) {
      tableData.push(
        this.renderActionRow(
          'inPlaceEditing',{ icon: faSave },
          <>Save Changes</>,
          <>You can only edit<br />from your own<br />production centre</>,
          null, null, TableRowAction.IN_PLACE_EDITING, dataObj, data, index,
          {
            disableCondition: !(!!this.props.inPlaceEditingRows && this.props.inPlaceEditingRows.some((editingRow) => editingRow.id === dataObj.id)),
            onSaveInPlaceEditing: inPlaceEditingAction.onSaveInPlaceEditing
          }
        )
      )
    }

    var popupContentAction = dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.POPUP_CONTENT &&
        this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )
    if (popupContentAction) {
      tableData.push(
        <OverlayTrigger
          key={`editPopupContent_${dataObj.id}`}
          placement='bottom'
          overlay={<Tooltip className='rowActionTooltip'>{popupContentAction.tooltipText ? popupContentAction.tooltipText : 'Popup Content'}</Tooltip>}
        >
          <td className='editPopupContent rowAction'>
            <PopupContent
              id={dataObj.id}
              title={popupContentAction.title}
              content={popupContentAction.content}
              button={<FontAwesomeIcon icon={popupContentAction.toggleIcon} />}
              isActive={this.props.editingRowIndex === dataObj.id}
              placement='bottom-end'
              onToggle={() => {
                if (this.props.editingRowIndex !== dataObj.id && !!popupContentAction.onClick)
                  popupContentAction.onClick()
                this.setEditingRow(this.props.editingRowIndex === dataObj.id ? -1 : dataObj.id)
              }}
            />
          </td>
        </OverlayTrigger>
      )
    }

    var downloadAllMediaAction = dataObj.rowActions.find(
      (action) =>
        action.action === TableRowAction.DOWNLOAD_ALL_MEDIA &&
            this.checkFolderPermission(action) // this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )

    if (downloadAllMediaAction) {
      tableData.push(
        this.renderActionRow(
          'downloadAllMedia', { imageUrl: 'images/download-all-icon.png' },
          <>Download {this.getTableOrPageName()}</>,
          null, null, null, TableRowAction.DOWNLOAD_ALL_MEDIA, dataObj, data, index, downloadAllMediaAction)
      )
    }

    // for delete row:
    var deleteRowAction = dataObj.rowActions.find(
       (action) =>
           action.action === TableRowAction.DELETE_ROW
       // && this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )
    const isDeleteVisible = (
       !this.props.folder ||
       this.checkFolderPermission(deleteRowAction)
        ) && (dataAction !== HubConstant.HUB_ACTION_STATE.ELASTIC_SEARCH);

    var lockUserName = deleteRowAction && deleteRowAction.lockUserName;
    var isLocked = deleteRowAction && deleteRowAction.isLocked;
    
    if (deleteRowAction) {
      if (this.state.idToConfirmDelete === dataObj.id) {
          tableData.push(

          <td
            key={`delete_${dataObj.id}`}
            className='onDelete'
            onMouseLeave={() => {this.setState({ idToConfirmDelete: -1, showConfirmDelete: false })}}
            ref={this.confirmDeleteRef}
            style={{
                pointerEvents: (isDeleteVisible && !isLocked) ? 'auto' : 'none',
            }}
          >
            <FontAwesomeIcon 
            icon = { isLocked ? faLock : faTrash }
            style={{
                visibility: isDeleteVisible ? 'visible' : 'hidden',
            }}
            />
            {
              (isDeleteVisible && !isLocked) ? (
                <Overlay
                  popperConfig={{
                    modifiers: [{ name: 'preventOverflow', enabled: false }, { name: 'hide', enabled: false }],
                  }}
                  show={this.state.showConfirmDelete}
                  target={this.state.confirmDeleteTarget}
                  placement='bottom'
                  container={this.confirmDeleteRef.current}
                  containerPadding={20}
                >
                  <Popover
                    className='confirmTooltip'
                    onClick={(e) => {
                      if (deleteRowAction.onDeleteRow) {
                        deleteRowAction.onDeleteRow(dataObj.id);
                      } else {
                        this.onRowAction(e, TableRowAction.DELETE_ROW, data, index);
                      }
                    }}
                  >
                    Are you sure? ✓
                  </Popover>
                </Overlay>
              ) : null
          }           
          </td>
        )
      } else {
        if(isDeleteVisible){
          tableData.push(
            <OverlayTrigger
              key={`onDelete_${dataObj.id}`}
              placement='bottom'
              overlay={<Tooltip className={`${!!this.props.activeTableName && this.props.activeTableName.singular === 'Value' ? 'vocabTooltip' : ''} rowActionTooltip`}
              >
                  {isLocked ? `Locked by ${lockUserName}` :
                  (!!this.props.requiredDataType &&
                  !!dataObj.Value &&
                  !Utilities.verifyDataHasCorrectDataType(dataObj.Value.val, parseInt(this.props.requiredDataType))
                    ? 'Wrong Data Type \n Please Fix via \n DataType Dropdown' : dataObj.canDelete !== undefined && !dataObj.canDelete
                    ? 'Built-in Data Field \n Cannot Be \n Deleted' : this.props.isInputDisabled
                    ? `Uncontrolled Value\nCannot Be Deleted` : `${
                        this.props.isPageless ? 'Remove\n' : 'Delete\n'
                      }${this.getTableOrPageName()}`)}
                </Tooltip>
              }
              popperConfig={{
                modifiers: [{ name: 'preventOverflow', enabled: false }, { name: 'hide', enabled: false }]
              }}
            >
              <td
                key={`delete_${dataObj.id}`}
                className={`${
                  !!this.props.isInputDisabled ||
                  (!!this.props.requiredDataType &&
                    !!dataObj.Value &&
                    !Utilities.verifyDataHasCorrectDataType(dataObj.Value.val, parseInt(this.props.requiredDataType))) ||
                    (dataObj.canDelete !== undefined && !dataObj.canDelete) ||
                    isLocked ? 'disabled disabledWithTooltip' : ''
                } onDelete`}
                onClick={(e) => {
                  // this.props.editMetadata(); //reset error msg TODO: Need to solve such redux dependency issue
                    // this.props.editNodeGroup(); //reset error msg
                  if (isLocked) {
                      // do nothing - story is locked
                  }
                  else if (!!this.props.requiredDataType && !!dataObj.Value && !Utilities.verifyDataHasCorrectDataType(dataObj.Value.val, parseInt(this.props.requiredDataType))) {
                    // do nothing
                  } else if (dataObj.canDelete !== undefined && !dataObj.canDelete) {
                    // do nothing
                  } else {
                    if (!this.props.isInputDisabled) {
                      if (this.props.isPageless) {
                        if (deleteRowAction.onDeleteRow) {
                          deleteRowAction.onDeleteRow(dataObj.id) // if the onDeleteRow prop exists within the action
                        } else {
                          this.onRowAction(e,TableRowAction.DELETE_ROW, data, index)
                        }
                      } else {
                        this.onRowAction(e, TableRowAction.CONFIRM_DELETE, data, index)
                      }
                    }
                  }
                }}
                style={{
                  pointerEvents: (isDeleteVisible && !isLocked) ? 'auto' : 'none',
                }}
              >
                <FontAwesomeIcon 
                  icon={isLocked ? faLock : (this.props.isPageless ? faMinusCircle : faTrash)}
                  style={{
                    visibility: isDeleteVisible ? 'visible' : 'hidden',
                  }}
                />
              </td>
            </OverlayTrigger>
          )
        } else {
          tableData.push(<td
            key={`delete_${dataObj.id}`}
            className={`${
              !!this.props.isInputDisabled ||
              (!!this.props.requiredDataType &&
                !!dataObj.Value &&
                !Utilities.verifyDataHasCorrectDataType(dataObj.Value.val, parseInt(this.props.requiredDataType))) ||
              (dataObj.canDelete !== undefined && !dataObj.canDelete) ? 'disabled disabledWithTooltip' : ''
            } onDelete`}
            onClick={(e) => {
              // this.props.editMetadata(); //reset error msg TODO: Need to solve such redux dependency issue
              // this.props.editNodeGroup(); //reset error msg
              if (!!this.props.requiredDataType && !!dataObj.Value && !Utilities.verifyDataHasCorrectDataType(dataObj.Value.val, parseInt(this.props.requiredDataType))) {
                // do nothing
              } else if (dataObj.canDelete !== undefined && !dataObj.canDelete) {
                // do nothing
              } else {
                if (!this.props.isInputDisabled) {
                  if (this.props.isPageless) {
                    if (deleteRowAction.onDeleteRow) {
                      deleteRowAction.onDeleteRow(dataObj.id) // if the onDeleteRow prop exists within the action
                    } else {
                      this.onRowAction(e,TableRowAction.DELETE_ROW, data, index)
                    }
                  } else {
                    this.onRowAction(e, TableRowAction.CONFIRM_DELETE, data, index)
                  }
                }
              }
            }}
            style={{
              pointerEvents: isDeleteVisible ? 'auto' : 'none',
            }}
          >
            <FontAwesomeIcon 
              icon={this.props.isPageless ? faMinusCircle : faTrash}
              style={{
                visibility: isDeleteVisible ? 'visible' : 'hidden',
              }}
            />
          </td>)
        }
        
      }
    }

    var navigateToActions = dataObj.rowActions.filter(
      (action) =>
        action.action === TableRowAction.NAVIGATE_TO &&
        this.props.authorizeService.getUserType() <= action.minAuthorityRequired
    )
    navigateToActions.forEach((navigateToAction, index) => {
      tableData.push(
        this.renderActionRow(
          `navigateTo${index}`,
          navigateToAction.icon ? { icon: navigateToAction.icon } : { icon: faArrowCircleRight },
          <Fragment key={`navigateTo${index}`}>Navigate To{navigateToAction.name ? ` ${navigateToAction.name}` : ''}</Fragment>,
          <Fragment key={`navigateTo${index}`}>You can only<br />Navigate To<br />from your own<br />production centre</Fragment>,
          null, null, TableRowAction.NAVIGATE_TO, dataObj, data, index, navigateToAction
        )
      )
    })
  }
    return tableData
  }
    render() {
        return this.generateTableRowData(this.props.data, this.props.dataObj, this.props.index, this.props.dataAction)
    }
}